<p-card styleClass="p-card-shadow mt-2" >
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="vendorWise"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'VendorName',
        'MIType',
        'TotalApplication',
        'VerifiedApplication',
        'ReturnProcessApplication',
        'PendingEarly',
        'Pending_1Week',
        'Pending_Morethan_1Weeks',
        'RejectedApplication',
        'Est_Amount',      
        'Mi_Area',
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'VENDOR_WISE_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pSortableColumn="VendorName">{{'VENDOR_NAME'| translate}}
                    <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                    <p-sortIcon field="VendorName"></p-sortIcon>
                </th>
                <th pSortableColumn="MIType">{{'MI_TYPE'| translate}}
                    <p-columnFilter type="text" field="MIType" display="menu"></p-columnFilter>
                    <p-sortIcon field="MIType"></p-sortIcon>
                </th>
                <th pSortableColumn="TotalApplication">{{'TOTAL_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="TotalApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="TotalApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="VerifiedApplication">{{'VERIFIED_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="VerifiedApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="VerifiedApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="ReturnProcessApplication">{{'RETURN_PROCESS_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="ReturnProcessApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="ReturnProcessApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="PendingEarly">{{'PENDING_IN_TIME'| translate}}
                    <p-columnFilter type="text" field="PendingEarly" display="menu"></p-columnFilter>
                    <p-sortIcon field="PendingEarly"></p-sortIcon>
                </th>
                <th pSortableColumn="Pending_1Week">{{'PENDING_A_WEEK'| translate}}
                    <p-columnFilter type="text" field="Pending_1Week" display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_1Week"></p-sortIcon>
                </th>
                <th pSortableColumn="Pending_Morethan_1Weeks">{{'PENDING_MORE_THEN_A_WEEK'| translate}}
                    <p-columnFilter type="text" field="Pending_Morethan_1Weeks" display="menu"></p-columnFilter>
                    <p-sortIcon field="Pending_Morethan_1Weeks"></p-sortIcon>
                </th>
                <th pSortableColumn="RejectedApplication">{{'REJECTED_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="RejectedApplication" display="menu"></p-columnFilter>
                    <p-sortIcon field="RejectedApplication"></p-sortIcon>
                </th>
                <th pSortableColumn="Est_Amount">{{'EST_AMOUNT'| translate}}
                    <p-columnFilter type="text" field="Est_Amount" display="menu"></p-columnFilter>
                    <p-sortIcon field="Est_Amount"></p-sortIcon>
                </th>
                <th pSortableColumn="Mi_Area">{{'MI_AREA'| translate}}
                    <p-columnFilter type="text" field="Mi_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="Mi_Area"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-vendorWise>
            <tr>
                <td>{{vendorWise.VendorName}}</td>
                <td>{{vendorWise.MIType}}</td>
                <td><a class="link_pointer" class="link_pointer" (click)="showMaximizableDialog_totalApp(vendorWise.Vendor_Code,vendorWise.MIType,vendorWise.VendorName)">{{vendorWise.TotalApplication}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(vendorWise.Vendor_Code,'Approved',vendorWise.MIType,vendorWise.VendorName)">{{vendorWise.VerifiedApplication}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(vendorWise.Vendor_Code,'Incomplete',vendorWise.MIType,vendorWise.VendorName)">{{vendorWise.ReturnProcessApplication}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(vendorWise.Vendor_Code,'early',vendorWise.MIType,vendorWise.VendorName)">{{vendorWise.PendingEarly}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(vendorWise.Vendor_Code,'1Week',vendorWise.MIType,vendorWise.VendorName)">{{vendorWise.Pending_1Week}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(vendorWise.Vendor_Code,'morethan_1Week',vendorWise.MIType,vendorWise.VendorName)">{{vendorWise.Pending_Morethan_1Weeks}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_rejected(vendorWise.Vendor_Code,vendorWise.MIType,vendorWise.VendorName)">{{vendorWise.RejectedApplication}}</a></td>
                <td>{{vendorWise.Est_Amount}}</td>
                <td>{{vendorWise.Mi_Area}}</td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td></td>
                <td >{{totalApp | number:'1.0-2'}}</td>
                <td >{{verfApp | number:'1.0-2'}}</td>
                <td >{{returnProcessApp | number:'1.0-2'}}</td>
                <td >{{onTime | number:'1.0-2'}}</td>
                <td >{{pendingByWeek | number:'1.0-2'}}</td>
                <td >{{pendingMoreThanWeek | number:'1.0-2'}}</td>
                <td >{{regectedApp | number:'1.0-2'}}</td>
                <td >{{estAmount | number:'1.0-2'}}</td>
                <td >{{miArea | number:'1.0-2'}}</td>
             </tr>
            <tr>
                <td > Grand Total</td>
                <td></td>
                <td >{{grandTotalApp | number:'1.0-2'}}</td>
                <td >{{grandVerfApp | number:'1.0-2'}}</td>
                <td >{{grandReturnProcessApp | number:'1.0-2'}}</td>
                <td >{{grandOnTime | number:'1.0-2'}}</td>
                <td >{{grandPendingByWeek | number:'1.0-2'}}</td>
                <td >{{grandPendingMoreThanWeek | number:'1.0-2'}}</td>
                <td >{{grandRegectedApp | number:'1.0-2'}}</td>
                <td >{{grandEstAmount | number:'1.0-2'}}</td>
                <td >{{grandMiArea | number:'1.0-2'}}</td>
             </tr>
        </ng-template>   
    
        </p-table>
    </div>
    </p-card>
    <p-dialog class="drilldown_details" [baseZIndex]="-100" header="Drill Down Vendor wise Estimation Verification Report Of {{approved_return}} Application of {{vendorName}} "  [(visible)]="displayMaximizable" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-approved-incomplete-report  *ngIf="displayMaximizable" [drilldownDetails]="drilldownDetails"></app-drill-down-approved-incomplete-report>
    
   </p-dialog>
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Vendor wise Estimation  Verification Report Of Total Application of {{vendorName}} "  [(visible)]="displayMaximizable_totalApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-total-report  *ngIf="displayMaximizable_totalApp" [drilldownDetails]="drilldownDetails"></app-drill-down-total-report>
   
  </p-dialog>
  <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Vendor wise Estimation Verification Report Of {{pendingType}} Application of {{vendorName}} "  [(visible)]="displayMaximizable_pendingApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-pending-report  *ngIf="displayMaximizable_pendingApp" [drilldownDetails]="drilldownDetails"></app-drill-down-pending-report>
   
  </p-dialog>
  <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Vendor wise Estimation Verification Report Of Rejected Application of {{vendorName}} "  [(visible)]="displayMaximizable_rejectedApp" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-rejected-report  *ngIf="displayMaximizable_rejectedApp" [drilldownDetails]="drilldownDetails"></app-drill-down-rejected-report>
   
  </p-dialog>